export const dataUriToFile = async (
  base64: string,
  contentType: string,
  filename: string,
): Promise<File> => {
  const response = await fetch(`data:${contentType};base64,${base64}`);
  const blob = await response.blob();
  return new File([blob], filename, { type: contentType });
};

export const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const toAllDayRange = (start: Date, end: Date | null): { start: Date; end: Date } => {
  const first = new Date(start);
  first.setHours(0, 0, 0, 0);
  const last = new Date(end && end.getTime() > first.getTime() ? end : start);
  last.setHours(23, 59, 0, 0);
  return { start: first, end: last };
};

export const toIsoValue = (date: Date | null | undefined): string | null =>
  date ? date.toISOString() : null;

export const fromIsoValue = (value: string | null): Date | null => (value ? new Date(value) : null);

export function fmtDate(d: Date | null): string {
  if (!d) return '-';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function fmtTime(d: Date | null): string {
  if (!d) return '';
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}

export function fmtWhen(d: Date | null | undefined): string {
  if (!d) return '';
  return `${d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} · ${fmtTime(d)}`;
}

export function fmtRange(start: Date | null | undefined, end: Date | null | undefined): string {
  if (!start && !end) return '';
  if (!start) return fmtWhen(end);
  if (!end) return fmtWhen(start);
  const sameDay = start.toDateString() === end.toDateString();
  if (sameDay) return `${fmtWhen(start)} – ${fmtTime(end)}`;
  return `${fmtWhen(start)} – ${fmtWhen(end)}`;
}
